import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { hasWindow } from "@omni/utils/dom.utils";
import * as SessionStorage from "@omni/utils/sessionStorage.utils";

import createValueModule from "@/redux/create-value-module";
import { StorageKeys } from "@/utils/enums";

import {
    $ProductDetailModuleName,
    TProductDetailState
} from "./productDetail.types";

export const getDeliveryType = (): DeliveryType => {
    if (hasWindow()) {
        return (
            (SessionStorage.getItem(
                StorageKeys.DeliveryType
            ) as DeliveryType) || DeliveryType.ClickAndCollect
        );
    }

    return DeliveryType.ClickAndCollect;
};

const { constants: _constants, actions } =
    createValueModule<TProductDetailState>($ProductDetailModuleName, {
        deliveryType: DeliveryType.ClickAndCollect,
        shop: null,
        quantity: 1,
        sku: "",
        stickyOrderButton: false,
        serviceProductSkus: []
    });

export const clear = actions.clear;
export const set = actions.set;
export const update = actions.update;

export const constants = _constants;
